var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.5V8.04902C2 6.60516 2 5.88322 2.24332 5.31647C2.5467 4.60985 3.10985 4.0467 3.81647 3.74332C4.38322 3.5 5.09805 3.5 6.54902 3.5H7.04311C7.64819 3.5 8.22075 3.77394 8.60041 4.24509L10.4175 6.5M10.4175 6.5H16C17.4001 6.5 18.1002 6.5 18.635 6.77248C19.1054 7.01217 19.4878 7.39462 19.7275 7.86502C20 8.3998 20 9.09987 20 10.5V11.5M10.4175 6.5H7",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15802 16.0144L3.45643 15.2717C4.19029 13.4449 4.55723 12.5316 5.3224 12.0158C6.08757 11.5 7.07557 11.5 9.05157 11.5H17.1119C19.8004 11.5 21.1446 11.5 21.7422 12.3787C22.3397 13.2575 21.8405 14.5002 20.842 16.9856L20.5436 17.7283C19.8097 19.5551 19.4428 20.4684 18.6776 20.9842C17.9124 21.5 16.9244 21.5 14.9484 21.5H6.88812C4.19961 21.5 2.85535 21.5 2.25782 20.6213C1.66029 19.7425 2.15953 18.4998 3.15802 16.0144Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder02);
export default __webpack_public_path__ + "static/media/folder-02.89e586155038efc44b58d765fc658231.svg";
export { ForwardRef as ReactComponent };